// extracted by mini-css-extract-plugin
module.exports = {"root":"Table_root__2iXaQ","head":"Table_head__3shED","col":"Table_col__keZB2"};